<template>
    <v-row justify="center">
      <v-dialog
        v-model="editModal"
        @keydown.esc="$emit('closeEditModal')"
        persistent
        max-width="600"
      >
        <v-card justify="center" class="p-3">
          <v-card-title>
            Edit Category
            <v-spacer />
            <v-btn icon @click="$emit('closeEditModal')">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <PageLoader ref="loader">
            <v-container>
              <v-form @submit.prevent="save" ref="form" lazy-validation>
                <v-row>
                  <v-col cols="9">
                    <v-text-field
                      v-model="category.name"
                      class="ml-4"
                      name="category"
                      label="Category"
                      outlined
                      dense
                      :rules="[(v) => !!v || 'Category Name is required']"
                    />
                  </v-col>
                  <v-col cols="3">
                    <v-btn color="secondary" type="submit" @click="save">
                      Save
                    </v-btn>
                  </v-col>
                </v-row>
              </v-form>
            </v-container>
          </PageLoader>
        </v-card>
      </v-dialog>
    </v-row>
</template>

<script lang="ts">
import api from '@/common/api';
import Vue from 'vue';
import PageLoader from '@/common/components/PageLoader.vue';
import { initCategory } from '@/merchant/views/categories/categories.types';


export default Vue.extend({
  watch: {
    editModal() {
      this.loadCategory();
    },
  },
  data() {
    return {
      name: '',
      category: initCategory(),
    };
  },
  props: {
    editModal: {
      type: Boolean,
    },
    id: {
      required: true,
      type: String,
    },
  },
  methods: {
    save() {
      if (!this.isValid()) {
        return;
      }
      this.$emit('updateCategory', this.category);
    },
    loadCategory() {
      if (this.$refs.loader) {
        (this.$refs.loader as any).setLoading();
      }
      api.get(`merchant/category/${this.id}`).then(this.setCategory)
        .catch(this.handleLoadingError);
    },
    setCategory({ data }: { data: any }) {
      this.category = data;
      (this.$refs.loader as any).setReady();
    },
    handleLoadingError(msg: string) {
      if (this.$refs.alertLoader) {
        (this.$refs.alertLoader as any).setReady();
      }
      this.$toasted.error(msg);
    },
    isValid(): boolean {
      return (this.$refs.form as any).validate();
    },
  },
  components: {
    PageLoader,
  },
});
</script>
